import {apiClient} from '@common/http/query-client';
import {useMutation} from '@tanstack/react-query';

export interface AiTopupLimits {
  tokens: number;
  per_day: number;
  per_month: number;
}

export interface AiTopupPack {
  key: string;
  label: string;
  credits_usd: number;
  discount_percent: number;
  pay_usd: number;
  limits: {
    'ai.text': AiTopupLimits;
    'ai.images': AiTopupLimits;
  };
}

export interface AiTopupSummary {
  enabled: boolean;
  currency: string;
  packs: AiTopupPack[];
  active_bonus: {
    text: AiTopupLimits;
    images: AiTopupLimits;
  };
  month_spend_usd: number;
}

interface CreateCheckoutPayload {
  pack: string;
  custom_amount?: number;
  return_path?: string;
}

interface CreateCheckoutResponse {
  checkout_url: string;
  session_id: string;
  credits_usd: number;
  discount_percent: number;
  pay_amount_usd: number;
}

interface ConfirmCheckoutResponse {
  id: number;
  status: string;
  credits_usd: number;
  amount_cents: number;
  currency: string;
  completed_at: string | null;
}

export function useCreateAiTopupCheckout() {
  return useMutation({
    mutationFn: (payload: CreateCheckoutPayload) =>
      createTopupCheckout(payload),
  });
}

export function useConfirmAiTopupCheckout() {
  return useMutation({
    mutationFn: (sessionId: string) => confirmTopupCheckout(sessionId),
  });
}

function createTopupCheckout(payload: CreateCheckoutPayload) {
  return apiClient
    .post<CreateCheckoutResponse>('ai/usage/topups/checkout', payload)
    .then(r => r.data);
}

function confirmTopupCheckout(sessionId: string) {
  return apiClient
    .post<ConfirmCheckoutResponse>('ai/usage/topups/confirm', {
      session_id: sessionId,
    })
    .then(r => r.data);
}
